<template>
  <div class="template-body">
    <!--面包屑部分-->
    <div class="ccui-navigation" ref="noPrintTop">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="purchaseBack"
        >返回
      </el-button>
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: '/announcement/announcementLists/all' }"
          >报价
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/inquiry/inquiryLists/offer' }"
          >采购询价
        </el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="!$route.query.isFirst"
          :to="{ path: '/inquiry/inquiryLists/' + thirdPath.path }"
          >{{ thirdPath.label }}
        </el-breadcrumb-item>
        <el-breadcrumb-item
          >{{ $route.query.isFirst || !detailsLists.isOff ? "报价" : "查看" }}
          <span class="ccui-curr-crumb ccui-ml-10">{{
            detailsLists.seekCode
          }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- <el-button type="text" @click="goodsDialogVisible = true">调试详情</el-button> -->
    <!--主体部分-->
    <div class="detail-box ccui-clearfix">
      <div class="detail-info">
        <img
          v-if="detailsLists.seekType === 4"
          :src="require('../inquiryLists/img/cancel.png')"
          style="width: 140px;height: 140px;position: absolute;right: 0;z-index: 1"
          alt=""
        />
        <div style="display: flex;background: #EBEBEB;position: relative">
          <div
            class="tab"
            @click="tabChange(item)"
            v-for="item in tabButton"
            :key="item.focus"
            :class="tabShow === item.value ? 'table-top-active' : 'table-top'"
          >
            {{ item.label }}
          </div>

          <div
            v-if="detailsLists.seekType === 3 || detailsLists.seekType === 2"
            style="position: absolute;right: -11px;top:29px"
          >
            <img
              style="width: 120px"
              :src="
                supplierCheckedStatusOption[detailsLists.supplierCheckedStatus]
              "
              alt=""
            />
          </div>
        </div>
        <div style="margin-top: 20px" v-if="tabShow === 1">
          <detailShow :baseInfo="baseInfo" :detailInformation="detailsLists" />
          <el-row>
            <el-col v-if="detailsLists.seekType === 4" :span="24">
              <div class="info-item">
                <span class="label">取消原因:</span>
                <span>{{ detailsLists.cancelReason }}</span>
              </div>
            </el-col>
          </el-row>
          <el-group-title
            title="商品信息"
            class="ccui-multifunctional-table-wrapper"
            style="padding: 0 20px;"
          >
            <template slot="groupTitle">
              <el-table
                class="ccui-multifunctional-table"
                :data="detailsLists.seekSkuList"
                border
                show-summary
                :summary-method="getSeekSkuListSummaries"
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column label="序号" width="50" fixed="left">
                  <template scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  :show-overflow-tooltip="true"
                  prop="skuName"
                  min-width="110px"
                />
                <el-table-column
                  label="所属四级类目"
                  :show-overflow-tooltip="true"
                  prop="cateryname"
                  width="140px"
                />
                <el-table-column
                  label="预计单价(含税)"
                  :show-overflow-tooltip="true"
                  prop="factoryUnitPrice"
                  header-align="left"
                  width="120"
                  align="right"
                  :formatter="figure"
                />
                <el-table-column
                  label="数量"
                  :show-overflow-tooltip="true"
                  prop="purchaseCount"
                  header-align="left"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  label="小计(含税)"
                  fixed="right"
                  :show-overflow-tooltip="true"
                  width="120"
                  header-align="left"
                  align="right"
                  prop="subtotal"
                  :formatter="figure"
                >
                </el-table-column>
                <el-table-column
                  label="是否支持替换"
                  fixed="right"
                  :show-overflow-tooltip="true"
                  width="120"
                  header-align="left"
                  prop="isReplaceGoods"
                >
                  <template scope="scope">
                    {{ scope.row.isReplaceGoods ? "是" : "否" }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-group-title>
          <el-card-title
            title="附件信息"
            style="margin-bottom: 20px"
            class="detail-info-form-title"
          ></el-card-title>
          <el-table
            :data="detailsLists.seekBaseInfoFiles"
            style="margin: 0 20px;width: calc(100% - 40px)"
            border
          >
            <el-table-column
              fixed="left"
              label="序号"
              type="index"
              width="50"
            />
            <el-table-column
              prop="fileName"
              label="附件名称"
              align="left"
              :show-overflow-tooltip="true"
              min-width="200px"
            />
            <el-table-column
              align="left"
              prop="fileSize"
              label="附件大小"
              min-width="100px"
            />
            <el-table-column
              prop="createTime"
              label="上传时间"
              align="left"
              min-width="150px"
            />
            <el-table-column label="操作" align="left" width="150px">
              <template v-slot="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="handleClick(scope.row, 1)"
                >
                  下载
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-card-title
            title="配送信息"
            style="margin-bottom: 20px"
            class="detail-info-form-title"
          ></el-card-title>
          <detailShow
            :baseInfo="distribution"
            :detailInformation="detailsLists"
          />
        </div>
        <div style="margin-top: 20px" v-if="tabShow === 2">
          <div
            style="border-bottom: 1px solid #D8D8D8;margin: 0 20px;padding: 0 10px;position: relative"
          >
            <h2
              style="font-weight: 600;font-size: 20px;color: #4A4A4A;margin-bottom: 20px"
            >
              询价标题：{{ detailsLists.seekTitle }}
            </h2>
            <div class="bodyText">
              <span class="bodyTextPadding"
                >询价截止时间 ：{{ detailsLists.seekOffTime }}</span
              >
              <span class="bodyTextPadding"
                >期望到货日期 ：{{ detailsLists.requiredDeliveryDate }}</span
              >
            </div>
            <div
              class="quotation"
              v-if="
                detailsLists.quoteType === 1 ||
                  (detailsLists.quoteType === 2 &&
                    this.detailsLists.isOff === 0)
              "
            >
              <div class="time">
                <span>{{ remainingTime.days }}</span
                >天 <span>{{ remainingTime.hours }}</span
                >小时<span>{{ remainingTime.minutes }}</span
                >分钟<span>{{ remainingTime.seconds }}</span
                >秒
              </div>
              <span>询价剩余时间</span>
            </div>
            <div v-else class="quotation">
              <div class="time">
                <span>00</span
                >天<span>00</span>小时<span>00</span>分钟<span>00</span>秒
              </div>
              <span>询价剩余时间</span>
            </div>
          </div>
          <div
            style="padding: 0 20px;position: relative;"
            class="ccui-multifunctional-table-wrapper"
          >
            <el-card-title
              title="报价清单"
              style="margin:0;margin-bottom: 20px"
              class="detail-info-form-title"
            ></el-card-title>
            <span style="color: red;position: absolute;top: 10px;left: 100px;"
              >注：您的报价将包含合同约定的服务费</span
            >
            <el-table
              v-if="isShow"
              :summary-method="getSummaries"
              :key="detailsListsTableKey"
              show-summary
              :row-key="row => row.seekSkuId"
              class="ccui-multifunctional-table"
              ref="detailsListsTable"
              :data="detailsLists.seekSupplierQuoteDetails"
              :span-method="objectSpanMethod"
              style="margin-bottom: 20px; width: 100%"
              border
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="50"
                fixed="left"
                align="center"
                v-if="!$route.query.type"
              />
              <!-- 序号列 -->
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="50"
              />

              <!-- 商品名称 -->
              <el-table-column
                label=""
                prop="skuName"
                :show-overflow-tooltip="true"
                align="left"
                min-width="200"
              >
                <template v-slot:header>
                  <div class="header-wrap">
                    询价商品名称
                    <el-tooltip class="item" effect="dark" placement="left-end">
                      <i
                        class="el-icon-warning-outline"
                        style="color: red;font-size: 18px;font-weight: 700;"
                      ></i>
                      <div slot="content">
                        若您所要报价的商品还未在商城铺货上架，请先完成铺货上架后再进行报价
                      </div>
                    </el-tooltip>
                  </div>
                </template>
                <template slot-scope="scope">
                  <el-tag
                    v-if="detailsLists.seekType == 3"
                    size="mini"
                    style="width: 50px;text-align: center;"
                    :type="scope.row.isChecked ? 'success' : 'danger'"
                    effect="dark"
                  >
                    {{ scope.row.isChecked ? "选中" : "未选中" }}
                  </el-tag>
                  {{ scope.row.skuName }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="purchaseCount"
                label="数量"
                min-width="80"
              />
              <el-table-column
                align="center"
                prop="cateryname"
                label="所属四级类目"
                min-width="120"
              />
              <el-table-column
                align="center"
                prop="isReplaceGoods"
                label="是否支持替换"
                min-width="90"
              >
                <template slot-scope="scope">
                  {{ scope.row.isReplaceGoods === 1 ? "是" : "否" }}
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                prop="newSkuName"
                :show-overflow-tooltip="true"
                label="报价商品名称"
                min-width="200"
              >
                <template slot-scope="scope">
                  {{ scope.row.newSkuName || scope.row.quoteSkuName || "-" }}
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                prop="shopName"
                :show-overflow-tooltip="true"
                label="所属店铺"
                min-width="120"
              >
                <template slot-scope="scope">
                  {{ scope.row.shopName || "-" }}
                </template>
              </el-table-column>
              <el-table-column align="right" width="120" prop="finalQuote">
                <template v-slot:header>
                  <div class="header-wrap">
                    <span class="required-red-icon">*</span>
                    报价单价(含税)
                  </div>
                </template>
                <template v-slot="scope">
                  <span
                    v-if="
                      $route.query.type === 'detail' ||
                        scope.row.matchSkuFlag == '2'
                    "
                  >
                    {{ scope.row.finalQuote.toFixed(2) || "-" }}
                  </span>
                  <el-input
                    class="curstom-input"
                    v-else
                    v-model="scope.row.finalQuote"
                    @input="handleInput(scope.row, 'finalQuote', scope.$index)"
                    @blur="handleBlur(scope.row, 'finalQuote', scope.$index)"
                    :placeholder="`请输入报价单价`"
                  />
                </template>
              </el-table-column>
              <el-table-column
                align="right"
                prop="subtotal"
                label="报价小计(含税)"
                min-width="120"
                :formatter="row => formatChange(row, 'subtotal')"
              >
              </el-table-column>
              <el-table-column
                align="right"
                prop="subtotalTaxExcluded"
                label="报价小计(不含税)"
                min-width="120"
                :formatter="row => formatChange(row, 'subtotalTaxExcluded')"
              >
              </el-table-column>
              <el-table-column
                align="right"
                prop="tax"
                label="税率"
                min-width="90"
                :formatter="row => `${row.newTax || row.tax}%`"
              >
                <template v-slot="scope">
                  <span
                    v-if="
                      $route.query.type === 'detail' ||
                        scope.row.matchSkuFlag == '2'
                    "
                  >
                    {{ `${scope.row.newTax || scope.row.tax}` || "-" }}
                  </span>
                  <el-input
                    class="curstom-input"
                    v-else
                    v-model="scope.row.tax"
                    @input="handleInput(scope.row, 'tax', scope.$index)"
                    @blur="handleBlur(scope.row, 'tax', scope.$index)"
                    :placeholder="`请输入税率`"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>

              <el-table-column
                align="right"
                label="税额"
                prop="taxFee"
                min-width="80"
              >
                <template v-slot="scope">
                  <span>
                    {{ scope.row.taxFee.toFixed(2) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label=""
                :min-width="120"
                fixed="right"
                v-if="!$route.query.type"
              >
                <template v-slot:header>
                  <div class="header-wrap">
                    操作

                    <el-tooltip class="item" effect="dark" placement="left-end">
                      <i
                        class="el-icon-warning-outline"
                        style="color: red;font-size: 18px;font-weight: 700;"
                      ></i>
                      <div slot="content">
                        对于支持替换的商品，您可以选择同品类商品进行替换
                      </div>
                    </el-tooltip>
                  </div>
                </template>
                <template slot-scope="{ row }">
                  <!-- v-if="row.isReplaceGoods === 1" -->
                  <el-button size="mini" type="text" @click="replaceGoods(row)">
                    替换商品
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!--            附件-->
            <div style="position: relative">
              <el-card-title
                title="附件说明"
                style="margin:0;margin-bottom: 20px"
                class="detail-info-form-title"
              ></el-card-title>
              <span
                style="position: absolute;top: 12px;left: 100px;font-size: 13px;color: #9B9B9B"
                >支持xlsx，xls，doc，docx，pdf,jpg，png，bmp，jpeg文件格式，大小不超过15MB</span
              >
              <div
                class="extend-btn"
                v-if="
                  detailsLists.quoteType === 1 ||
                    (detailsLists.quoteType === 2 &&
                      detailsLists.isOff === 0 &&
                      !$route.query.type)
                "
              >
                <el-upload
                  class="upload-demo tow"
                  accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png, .bmp, .jpeg"
                  :action="uploadUrl"
                  multiple
                  :on-remove="handleRemove"
                  :on-success="uploadHandler"
                  :on-error="uploadError"
                  :before-upload="beforeUpload"
                  :on-progress="onProgress"
                  :headers="headers"
                  :show-file-list="false"
                  ref="uploadItem"
                >
                  <el-button
                    type="text"
                    style="color: #0089EF;border: 1px solid #0089EF;font-size: 13px;border-radius: 0;padding: 6px 9px;position: absolute;top: 20%;right: 0"
                    >上传文件
                  </el-button>
                </el-upload>
              </div>
            </div>
            <el-table
              :data="detailsLists.seekFiles"
              style="margin-bottom:20px;width: 100%"
              border
            >
              <el-table-column
                fixed="left"
                label="序号"
                type="index"
                width="50"
              />
              <el-table-column
                prop="fileName"
                label="附件名称"
                align="left"
                :show-overflow-tooltip="true"
                min-width="200px"
              />
              <el-table-column
                align="left"
                prop="fileSize"
                label="附件大小"
                min-width="100px"
              />
              <el-table-column
                prop="createTime"
                label="上传时间"
                align="left"
                min-width="150px"
              />
              <el-table-column label="操作" align="left" width="150px">
                <template v-slot="scope">
                  <el-button
                    size="mini"
                    v-for="e in accessoryOptions(scope.row)"
                    :key="e.value"
                    type="text"
                    @click="handleClick(scope.row, e.value)"
                  >
                    {{ e.label }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div
              style="font-weight: 400;font-size: 13px;color: #4A4A4A;display: flex"
            >
              <span style="white-space: nowrap;">报价说明：</span>
              <el-input
                v-if="
                  detailsLists.quoteType === 1 ||
                    (detailsLists.quoteType === 2 &&
                      detailsLists.isOff === 0 &&
                      !$route.query.type)
                "
                type="textarea"
                v-model="detailsLists.quoteDescription"
                maxlength="500"
                show-word-limit
                :rows="5"
              ></el-input>
              <div v-else>{{ detailsLists.quoteDescription }}</div>
            </div>
            <el-card-title
              title="供货商信息"
              style="margin:20px 0"
              class="detail-info-form-title"
            ></el-card-title>
            <el-form
              ref="supplierForm"
              :model="supplierForm"
              :rules="supplierFormRules"
              :inline="true"
              label-width="160px"
            >
              <el-form-item label="报价对接人：" prop="quoteUserName">
                <span v-if="$route.query.type">{{
                  supplierForm.quoteUserName
                }}</span>
                <el-input
                  v-else
                  v-model="supplierForm.quoteUserName"
                  style="width: 300px"
                  placeholder="请输入报价对接人"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="联系方式：" prop="quoteUserPhone">
                <span v-if="$route.query.type">{{
                  supplierForm.quoteUserPhone
                }}</span>
                <el-input
                  v-else
                  v-model="supplierForm.quoteUserPhone"
                  maxlength="11"
                  style="width: 300px"
                  placeholder="请输入联系方式"
                  clearable
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        :width="dialogTitle === '库存预警' ? '60%' : '478px'"
        max-height="400px"
        :before-close="handleClose"
      >
        <div v-if="dialogTitle === '库存预警'" style="padding: 20px 0">
          <span style="font-size: 13px;color: #FF142F"
            >商品库存不足，请核实并及时补足库存，以确保供货无忧！</span
          >
          <el-table
            ref="dialogDetailsListsTable"
            :data="seekSkuReqBOList"
            style="width: 100%"
            border
            class="detailsListsTable"
          >
            <el-table-column label="商品信息" align="left" width="130px">
              <template v-slot="scope">
                <div>商品名称：</div>
                <div>{{ scope.row.skuName }}</div>
                <div>品牌：{{ scope.row.brandName }}</div>
                <div>计量单位：{{ scope.row.unitName }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="purchaseCount"
              label="数量/重量"
              align="left"
              width="130px"
            />
            <el-table-column
              prop="stockNum"
              label="库存数量"
              align="left"
              width="130px"
            />
          </el-table>
        </div>
        <div v-else class="dialogBody">
          <div>本次报价总金额(CNY-人民币)：{{ aggregateAmount }}</div>
          <div>大写金额： {{ numberToChinese(aggregateAmount) }}</div>
          <div>您是否确认提交？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogSubmit(dialogTitle)"
            >确 认</el-button
          >
        </span>
      </el-dialog>

      <goodsList
        :dialogVisible.sync="goodsDialogVisible"
        :curGoods="curGoods"
        @replace="handleReplaceGoods"
      />

      <!--底部功能按钮-->
      <el-bottom-guide>
        <ul class="ccui-bottom-button" ref="noPrintBottom">
          <li>
            <el-button
              type="bottom"
              icon="icon-ccui-return"
              @click="purchaseBack"
              >返回
            </el-button>
          </li>
          <div
            v-if="
              filteredOptions(detailsLists).length > 0 && !$route.query.type
            "
            class="ccui-bottom-guide-divider"
          />
          <template v-if="!$route.query.type">
            <li
              style="display: flex;align-items: center"
              v-for="item in filteredOptions(detailsLists)"
              :key="item.value"
            >
              <el-button type="bottom" @click="handlePurchase(item.label)">
                <div style="display: flex;align-items: center">
                  <img
                    v-if="
                      item.img &&
                        item.label === '提交报价' &&
                        !$route.query.type
                    "
                    style="width: 16px;height: 16px"
                    :src="item.img"
                    alt=""
                  />
                  <div style="margin-left: 5px">
                    {{ item.label }}
                  </div>
                </div>
              </el-button>
            </li>
          </template>
        </ul>
      </el-bottom-guide>
    </div>
  </div>
</template>
<script>
import detailShow from "./components/detailShow.vue";
import goodsList from "./components/goodsList.vue";
import Cookies from "js-cookie";
import {
  // queryNewSeekSkuForSupplier,
  ecSupplierQuote,
  // getShowPrice,
  getShowFinalQuotePrice,
  supplierRegister
} from "@/app/electronicQuotation/api/all";
import {
  queryNewSeekDetailForSupplier,
  filePreview
} from "@/app/inquiry/api/all";
import { addUrlPerFix } from "@/config/utils";
const VUE_APP_UPLOAD_URL = addUrlPerFix(process.env.VUE_APP_UPLOAD_URL);

export default {
  components: {
    detailShow,
    goodsList
  },
  data() {
    return {
      detailsListsTableKey: true,
      uploadUrl: VUE_APP_UPLOAD_URL, // 上传地址
      headers: {
        Authorization: Cookies.get("access_token") || ""
      },
      supplierCheckedStatusOption: {
        0: require("./img/未中标@3x.png"),
        1: require("./img/全部中标@3x.png"),
        2: require("./img/部分中标@3x.png"),
        "-1": require("./img/待定标@3x.png")
      },
      accessoryButton: [
        {
          value: 1,
          label: "下载"
        },
        {
          value: 2,
          label: "预览"
        },
        {
          value: 3,
          label: "删除"
        }
      ],
      remainingTime: {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00"
      },
      optionButton: [
        {
          value: 1,
          label: "提交报价",
          img: require("./img/submat.png")
        }
      ],
      detailsLists: {
        seekSupplier: {
          quoteType: null
        }
      },
      tableSelectLists: [],
      tabShow: 2,
      seekSkuReqBOList: [], //库存预警
      tabButton: [
        {
          value: 1,
          label: "基本信息"
        },
        {
          value: 2,
          label: "报价信息"
        }
      ],
      // 基本信息
      baseInfo: [
        // 新增的东西
        {
          value: "schemeTypeName",
          label: "方案类型",
          row: 12,
          isShow: false
        },
        // 新增的东西
        {
          value: "doDeptName",
          label: "经办单位",
          row: 12,
          isShow: false
        },
        {
          value: "paymentCycle",
          label: "付款周期(天)",
          row: 24,
          isShow: true
        },
        {
          value: "doDeptName",
          label: "经办单位/部门",
          row: 12,
          isShow: true
        },
        {
          value: "purchaseOrgName",
          label: "采购单位",
          row: 12,
          isShow: true
        },
        {
          value: "purchaseType",
          label: "采购类型",
          row: 12,
          isShow: true
        },
        {
          value: "doUnitUserName",
          label: "采购人",
          row: 12,
          isShow: true
        },
        // 新增的东西
        {
          value: "doUnitUserPhone",
          label: "联系方式",
          row: 12,
          isShow: true
        },
        {
          value: "seekTitle",
          label: "询价标题",
          row: 12,
          isShow: true
        },
        {
          value: "seekCode",
          label: "询价单号",
          row: 12,
          isShow: true
        },
        {
          value: "seekOffTime",
          label: "询价截止时间",
          row: 12,
          isShow: true
        },
        {
          value: "requiredDeliveryDate",
          label: "期望到货日期",
          row: 12,
          isShow: true
        },
        {
          value: "purchaseRequestDescription",
          label: "补充说明",
          row: 24,
          isShow: true
        }
      ],
      // 交货
      delivery: [
        {
          value: "paymentMethod",
          label: "付款方式",
          row: 12,
          type: "paymentMethod",
          isShow: true
        },
        {
          value: "invoiceType",
          label: "发票类型",
          row: 12,
          type: "invoiceType",
          isShow: true
        },
        {
          value: "invoiceAgreement",
          label: "开票约定",
          row: 12,
          isShow: true
        },
        {
          value: "transportationMethod",
          label: "运输方式",
          row: 12,
          type: "transportationMethod",
          isShow: true
        },
        {
          value: "deliveryMethod",
          label: "交货方式",
          row: 12,
          type: "deliveryMethod",
          isShow: true
        },
        {
          value: "paymentTerms",
          label: "付款条件",
          row: 24,
          isShow: true
        }
      ],
      // 配送
      distribution: [
        {
          value: "requiredDeliveryDate",
          label: "要求到货日期",
          row: 12,
          format: "time",
          isShow: false
        },
        {
          value: "receiverName",
          label: "收货人信息",
          row: 12,
          isShow: true
        },
        {
          value: "deliveryTime",
          label: "配送时间",
          row: 12,
          type: "deliveryTime",
          isShow: true
        },
        {
          value: "deliveryRequirements",
          label: "送货要求",
          row: 24,
          isShow: false
        },
        {
          value: "projectName",
          label: "项目名称",
          row: 24,
          isShow: false
        }
      ],
      quoteDescription: "", //报价说明
      dialogTitle: "",
      dialogVisible: false,
      aggregateAmount: null,
      curGoods: {},
      goodsDialogVisible: false,
      supplierForm: {
        quoteUserName: "",
        quoteUserPhone: ""
      },
      supplierFormRules: {
        quoteUserName: [
          { required: true, message: "请输入报价对接人", trigger: "change" }
        ],
        quoteUserPhone: [
          { required: true, message: "请输入联系方式", trigger: "change" },
          {
            validator: this.mobileValidate,
            message: "请输入正确格式的手机号码",
            trigger: "change"
          }
        ]
      },
      isShow: true,
      oldSeekSupplierQuoteDetails: []
    };
  },
  computed: {
    thirdPath() {
      return JSON.parse(sessionStorage.getItem("inquiryPathData"));
    }
  },
  watch: {
    tableSelectLists(data) {
      console.log("🚀 ~ tableSelectLists ~ data:", data);
      const values = data.map(item => {
        const value = Number(item.subtotal);
        return isNaN(value) ? 0 : value; // 确保每个值都是数字
      });
      this.aggregateAmount = values
        .reduce((prev, curr) => prev + curr, 0)
        .toFixed(2); // 计算总和
    }
  },
  created() {
    if (this.$route.query.status === 2) {
      supplierRegister({
        seekId: this.$route.query.seekId,
        seekSupplierId: this.$route.query.seekSupplierId
        // seekId: this.$route.params.id,
        // seekSupplierId: this.$route.params.seekSupplierId
      }).then(res => {
        if (res.data.code == "0") {
          this.getInit();
        }
      });
    }
    // this.getInit();
  },
  activated() {
    this.detailsLists = {};
    this.tabShow = 2;
    this.getInit();
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem("currentTab");
    sessionStorage.removeItem("inquiryPathData");
    next();
  },
  methods: {
    figure(row, column, cellValue) {
      if (row[column.property]) {
        return Number(row[column.property]).toFixed(2);
      }
    },
    mobileValidate(rule, value, callback) {
      let regexp = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (value) {
        if (value.match(regexp)) {
          callback();
        } else {
          callback(new Error(rule.message || "请输入正确的手机号"));
        }
      } else {
        callback();
      }
    },
    getInit() {
      queryNewSeekDetailForSupplier({
        seekId: this.$route.query.seekId,
        supplierId: this.$route.query.supplierId,
        // seekSupplierId: this.$route.query.seekSupplierId,
        // seekId: this.$route.params.id,
        // seekSupplierId: this.$route.params.seekSupplierId,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          const detail = res.data.data;
          let spanCount = 0;
          detail.seekSupplierQuoteDetails.forEach((item, index) => {
            // 重新定义唯一值
            item.key = `${item.shopId}-${item.seekSkuId}`;
            if (
              index === 0 ||
              item.seekSkuId !==
                detail.seekSupplierQuoteDetails[index - 1].seekSkuId
            ) {
              spanCount = 1;
              let next = index + 1;
              while (
                next < detail.seekSupplierQuoteDetails.length &&
                detail.seekSupplierQuoteDetails[next].seekSkuId ===
                  item.seekSkuId
              ) {
                spanCount++;
                next++;
              }
              item.rowspan = spanCount;
            } else {
              item.rowspan = 0;
            }
          });
          console.log("🚀 ~ getInit ~ detail:", { ...detail });
          this.detailsLists = detail;
          this.tableSelectLists = this.detailsLists.seekSupplierQuoteDetails.filter(
            item => {
              return item.isQuoted == 1;
            }
          );

          console.log(this.tableSelectLists, "tableSelectLists");

          this.oldSeekSupplierQuoteDetails = JSON.parse(
            JSON.stringify(detail.seekSupplierQuoteDetails)
          );
          const { quoteUserName, quoteUserPhone } = detail;
          this.supplierForm = {
            quoteUserName,
            quoteUserPhone
          };
          const isSourceSystem2 = detail.sourceSystem === 2;

          this.baseInfo = this.baseInfo.map(item => {
            if (
              ["schemeTypeName", "planName", "planCode"].includes(item.value) ||
              item.label === "经办单位"
            ) {
              return {
                ...item,
                isShow: isSourceSystem2
              };
            }

            if (item.label === "经办单位/部门") {
              return {
                ...item,
                isShow: !isSourceSystem2
              };
            }
            return item;
          });
          this.startCountdown();
        }
        this.isShow = false;
        setTimeout(() => {
          this.isShow = true;
          this.$nextTick(() => {
            this.tableSelectLists.forEach(item => {
              this.$refs.detailsListsTable.toggleRowSelection(item, true);
            });
          });
        }, 50);
      });
    },
    handleSelectionChange(rows) {
      this.tableSelectLists = rows;
    },
    replaceGoods(row) {
      this.curGoods = {
        ...row,
        supplierId: this.detailsLists.supplierId,
        supplierCode: this.detailsLists.supplierCode
      };
      this.goodsDialogVisible = true;
    },
    purchaseBack() {
      // this.$router.go(-1);
      this.$router.push("/inquiry/inquiryLists/offer");
    },
    filteredOptions(row) {
      // if (!this.detailsLists.seekSupplier) {
      //   return []; // 如果数据尚未加载完成，返回空数组
      // }

      const quoteType = this.detailsLists.quoteType;
      const optionsMap = {
        1: [this.optionButton[0]],
        2: this.detailsLists.isOff === 1 ? [] : [this.optionButton[0]],
        3: this.detailsLists.isOff === 1 ? [] : [this.optionButton[0]]
      };
      return optionsMap[quoteType] || [];
    },
    // 新增的东西
    showChange(label, row) {
      if (label === "pricingMethods") {
        return row === 1
          ? "包月"
          : row === 2
          ? "台班"
          : row === 3
          ? "工程量"
          : row === 4
          ? "按天计"
          : row === 5
          ? "按小时计"
          : row === 6
          ? "一口价"
          : row === 7
          ? "项"
          : "-";
      } else if (label === "rentalTime") {
        return row;
      } else {
        if (typeof row === "number" && !isNaN(row)) {
          return row.toFixed(2);
        } else {
          return row;
        }
      }
    },
    accessoryOptions(row) {
      // if (!this.detailsLists.seekSupplier) {
      //   return []; // 如果数据尚未加载完成，返回空数组
      // }
      // console.log(this.detailsLists.seekSupplier, 123132123);
      // 判断 row.fileName 的尾缀是否是 png、jpg 或 gif
      const hasImageExtension = /\.(png|jpg|gif|pdf)$/i.test(row.fileName);

      // 根据 hasImageExtension 判断是否包括 this.accessoryButton[1]
      const optionsMap = {
        1: [
          this.accessoryButton[0],
          hasImageExtension ? this.accessoryButton[1] : null,
          this.$route.query.type ? null : this.accessoryButton[2]
        ].filter(Boolean), // 移除 null 值
        2:
          this.detailsLists.isOff === 1
            ? [
                this.accessoryButton[0],
                hasImageExtension ? this.accessoryButton[1] : null
              ].filter(Boolean)
            : [
                this.accessoryButton[0],
                hasImageExtension ? this.accessoryButton[1] : null,
                this.$route.query.type ? null : this.accessoryButton[2]
              ].filter(Boolean), // 移除 null 值
        3: [
          this.accessoryButton[0],
          hasImageExtension ? this.accessoryButton[1] : null
        ].filter(Boolean) // 移除 null 值
      };
      return optionsMap[this.detailsLists.quoteType] || [];
    },
    handlePurchase(dialogTitle) {
      // 检查是否所有项都填写了固定费用和运费
      if (!this.tableSelectLists.length) {
        return this.$message({
          message: "请选中报价清单中的商品进行提交",
          type: "error",
          duration: 3000,
          ccuiCustom: true,
          showClose: true
        });
      }
      const isComplete = this.tableSelectLists.every(item => {
        // 判断 finalQuote 是否有效
        const isFinalQuoteValid =
          item.finalQuote !== null &&
          item.finalQuote !== undefined &&
          item.finalQuote !== 0 &&
          item.finalQuote !== "";
        // 如果存在未填字段或 finalQuote 无效，提示错误并返回 false
        if (!isFinalQuoteValid) {
          this.$message({
            message: "请完善报价信息",
            type: "error",
            duration: 3000,
            ccuiCustom: true,
            showClose: true
          });
          return false;
        }
        // 如果所有校验通过，返回 true
        return true;
      });

      // 如果没有完整填写，停止执行
      if (!isComplete) return;

      // 校验供货商信息
      console.log(this.$refs["supplierForm"], 'this.$refs["supplierForm"]');

      this.$refs["supplierForm"].validate(valid => {
        if (!valid) {
          this.$nextTick(() => {
            const errorFormEl = document.body.querySelector(".is-error");
            const errorText = errorFormEl.firstChild.innerText;
            const messageText = errorText.substring(
              0,
              errorText.lastIndexOf("：")
            );
            this.$showErrorMessage(`${messageText}未填写，请填写完整`);
            if (errorFormEl) {
              errorFormEl.scrollIntoView({
                behavior: "smooth", // 平滑过渡
                block: "start" // 上边框与视窗顶部平齐。默认值
              });
            }
          });
          return;
        }

        // 如果标题是 "提交报价"，显示对话框并更改标题
        if (dialogTitle === "提交报价") {
          // this.dialogTitle = "库存预警";
          // queryNewSeekSkuForSupplier({
          //   seekId: this.detailsLists.seekId,
          //   // seekSupplierId: this.detailsLists.seekSupplier.seekSupplierId,
          //   isShowLoading: true
          // }).then(res => {
          //   if (res.data.code === "0") {
          //     if (res.data.data.isShow) {
          //       this.dialogVisible = true;
          //       this.seekSkuReqBOList = res.data.data.seekSkuRspBOList;
          //     } else {
          //       this.dialogTitle = "报价确认";
          //       this.dialogVisible = true;
          //     }
          //   }
          // });
          this.dialogTitle = "报价确认";
          this.dialogVisible = true;
        }
      });
    },
    handleReplaceGoods(data) {
      const { seekSupplierQuoteDetails } = this.detailsLists;
      const newData = seekSupplierQuoteDetails.map(item =>
        item.key === data.key ? data : item
      );
      this.$set(this.detailsLists, "seekSupplierQuoteDetails", newData);
      console.log(
        "🚀 ~ handleReplaceGoods ~ this.detailsLists:",
        this.detailsLists
      );
      this.detailsListsTableKey = false;
      this.$nextTick(() => {
        this.detailsListsTableKey = true;
      });
      this.handleBlur(data, "finalQuote");
      console.log(this.$refs.detailsListsTable, "this.$refs.detailsListsTable");
    },
    dialogSubmit(title) {
      if (title === "库存预警") {
        this.dialogVisible = false;
        setTimeout(() => {
          this.dialogTitle = "报价确认";
          this.dialogVisible = true;
        }, 300);
      } else if (title === "报价确认") {
        const { quoteUserName, quoteUserPhone } = this.supplierForm;
        let arr = {
          seekId: this.detailsLists.seekId, //询价单主键id
          seekCode: this.detailsLists.seekCode, //询价单编号
          // seekSupplierId: this.detailsLists.seekSupplier.seekSupplierId, //报名供货商主键id
          quoteDescription: this.detailsLists.quoteDescription,
          seekFileBOList: this.detailsLists.seekFiles, //附件IP地址
          seekSupplierQuoteDetailsBOList: this.tableSelectLists,
          quoteUserName,
          quoteUserPhone,
          supplierId: this.$route.query.supplierId
        };

        this.dialogVisible = false;
        ecSupplierQuote({ ...arr, isShowLoading: true }).then(res => {
          if (res.data.code === "0") {
            this.$message({
              showClose: true,
              message: `报价成功`,
              type: "success",
              ccuiCustom: true
            });
            // this.$router.go(-1);
            this.$router.push("/inquiry/inquiryLists/offer");
          }
        });
      }
    },
    tabChange(item) {
      this.tabShow = item.value;
      localStorage.setItem("currentTab", item.value);
    },
    getSeekSkuListSummaries({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (["subtotal"].includes(column.property)) {
          sums[index] = values
            .reduce((prev, curr) => prev + (isNaN(curr) ? 0 : curr), 0)
            .toFixed(2);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    getSummaries(param) {
      const { columns, data } = param;
      console.log(data);

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = {
            text: "合计",
            isRed: true
          };
          return;
        }

        if (["subtotal", "taxFee"].includes(column.property)) {
          let arr = [];
          if (this.$route.query.type === "detail") {
            arr = data;
          } else {
            arr = this.tableSelectLists;
          }
          const values = arr.map(item => {
            const value = Number(item[column.property]);
            console.log(item[column.property], index);

            return isNaN(value) ? 0 : value; // 确保每个值都是数字
          });
          // sums[index] = {
          //   text: values.reduce((prev, curr) => prev + curr, 0).toFixed(2) // 计算总和
          // };
          this.$set(sums, index, {
            text: values.reduce((prev, curr) => prev + curr, 0).toFixed(2) // 计算总和
          });
          if (index === 9) {
            this.aggregateAmount = sums[index].text;
          }
        } else {
          sums[index] = { text: "" }; // 其他列的合计为空
        }
      });

      return sums;
    },
    handleRemove(file, fileList) {},
    uploadHandler(res, file, fileList) {
      this.$message.closeAll();
      this.$message({
        showClose: true,
        message: `附件上传成功`,
        type: "success",
        ccuiCustom: true
      });
      this.uploadLoading.close();
      let fileData = res.data[0];
      this.detailsLists.seekFiles.push({
        uploadId: fileData.uploadId,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024) + "kb",
        createTime: fileData.createTime,
        fileUrl: fileData.downloadUrl
      });
      // this.enterpriseRuleForm.submitFileInfoBO.uploadIds = []
      // this.tableData.forEach((item) => {
      //   this.enterpriseRuleForm.submitFileInfoBO.uploadIds.push(item.uploadId)
      // })
    },
    uploadError(res, file, fileList) {
      if (res.code != "0") {
        this.$message.closeAll();
        this.$message({
          showClose: true,
          type: "error",
          ccuiCustom: true,
          message: res.message
        });
      }
    },
    beforeUpload(file) {
      const isLt15 = file.size < 15728640;
      var testmsg = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      const extension =
        testmsg === "xls" ||
        testmsg === "xlsx" ||
        testmsg === "jpg" ||
        testmsg === "docx" ||
        testmsg === "doc" ||
        testmsg === "pdf" ||
        testmsg === "png" ||
        testmsg === "bmp" ||
        testmsg === "jpeg";
      if (!isLt15) {
        this.$message({
          showClose: true,
          message: "文件大小不超过15M!",
          type: "error",
          ccuiCustom: true,
          duration: 0
        });
      }
      if (!extension) {
        this.$message({
          showClose: true,
          message:
            "上传文件只能是 pdf、doc、docx、xls、xlsx、jpg、jpeg、png、bmp格式!",
          type: "error",
          ccuiCustom: true,
          duration: 0
        });
      }
      return isLt15 && extension;
    },
    onProgress(progressEvent) {
      this.uploadLoading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    startCountdown() {
      const endTime = new Date(this.detailsLists.seekOffTime).getTime();
      this.intervalId = setInterval(() => {
        this.calculateTime(endTime);
      }, 1000);
    },
    calculateTime(endTime) {
      const now = new Date().getTime();
      const timeDiff = endTime - now;

      if (timeDiff <= 0) {
        clearInterval(this.intervalId);
        this.remainingTime = {
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00"
        };
        return;
      }

      const totalDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const totalHours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      this.remainingTime.days = String(totalDays).padStart(2, "0");
      this.remainingTime.hours = String(totalHours).padStart(2, "0");
      this.remainingTime.minutes = String(minutes).padStart(2, "0");
      this.remainingTime.seconds = String(seconds).padStart(2, "0");
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        ["skuName", "purchaseCount", "cateryname", "isReplaceGoods"].includes(
          column.property
        )
      ) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    handleClick(row, value) {
      if (value === 1) {
        let openUrl = document.createElement("a");
        openUrl.style.display = "none";
        openUrl.href =
          `${addUrlPerFix(
            process.env.VUE_APP_BASE_URL
          )}/apis/ebs/uploadFile/downloadByUrl?downloadUrl=${
            row.fileUrl
          }&fileName=` + encodeURIComponent(row.fileName);
        openUrl.setAttribute("download", row.fileName);
        console.log(openUrl, "openUrl");
        document.body.appendChild(openUrl);
        openUrl.click();
      } else if (value === 2) {
        // window.open(row.fileUrl, "_blank");
        filePreview({ uploadId: row.uploadId }).then(res => {
          console.log(res.data);
          window.open(res.data.data, "_blank");
        });
      } else {
        const index = this.detailsLists.seekFiles.indexOf(row);
        if (index > -1) {
          // 从数组中删除当前行
          this.detailsLists.seekFiles.splice(index, 1);
        }
      }
    },
    formatChange(row, prop) {
      return parseFloat(row[prop]).toFixed(2);
    },

    handleInput(obj, prop, index) {
      let row = this.detailsLists.seekSupplierQuoteDetails[index];
      let value = row[prop];

      const allowNegative = prop === "otherFees" || prop === "fixedUnitPrice";
      const numberPattern = allowNegative
        ? /^-?\d*(\.\d{0,2})?$/ // 允许负数
        : /^\d*(\.\d{0,2})?$/; // 不允许负数

      // 移除非数字和小数点的非法字符（包括负号，如果不允许负数）
      value = value.replace(allowNegative ? /[^0-9.-]/g : /[^0-9.]/g, "");

      // 检查是否有多个小数点
      const dotCount = (value.match(/\./g) || []).length;
      if (dotCount > 1) {
        // 如果有多个小数点，保留第一个并删除其余的
        value = value
          .split(".")
          .slice(0, 2)
          .join(".");
      }

      // 如果允许负数，检查负号的位置（只能在最前面）
      if (allowNegative && value.indexOf("-") > 0) {
        value = "-" + value.replace(/-/g, "");
      }

      // 校验是否为非法的零开头（如 "012123"）
      if (/^0\d/.test(value)) {
        // 自动转换为合法的 "0.xxx" 格式
        value = `0.${value.slice(1)}`;
      }

      // 校验是否符合数字格式
      if (!numberPattern.test(value)) {
        // 如果只输入了小数点，自动补全为 "0."
        if (value === ".") {
          value = "0.";
        }
        // 如果包含非法字符，删除最后一个非法字符
        else {
          value = value.slice(0, -1);
        }
      }

      // 最终更新 row[prop] 的值
      row[prop] = value;
      this.detailsLists.seekSupplierQuoteDetails.forEach((item, index1) => {
        console.log(row.skuId, item.skuId);
        if (row.newSkuId) {
          if (row.newSkuId == item.skuId) {
            this.$set(item, prop, value);
          }
        } else {
          if (row.skuId == item.skuId && item.newSkuId == 0) {
            this.$set(item, prop, value);
          }
        }
      });
    },
    handleBlur(obj, prop, index) {
      let row = index ? this.detailsLists.seekSupplierQuoteDetails[index] : obj;
      // let row = obj
      // if (prop === "finalQuote") {
      // 检查输入是否为空或无效
      if (row[prop] === undefined || row[prop] === null || row[prop] === "") {
        return false;
      }
      if (row.newSkuId == 0) {
        this.detailsLists.seekSupplierQuoteDetails.forEach(
          (item, itemIndex) => {
            if (item.newSkuId == 0) {
              if (row.skuId == item.skuId) {
                if (prop === "tax") {
                  if (
                    this.oldSeekSupplierQuoteDetails[itemIndex].tax == item.tax
                  ) {
                    this.$set(item, "taxChangeFlag", 0);
                  } else {
                    this.$set(item, "taxChangeFlag", 1);
                  }
                }
                getShowFinalQuotePrice(item).then(res => {
                  if (res.data.code === "0") {
                    const responseObject = res.data.data;
                    // 遍历返回对象，将值合并到 row 中
                    Object.keys(responseObject).forEach(key => {
                      // row[key] = responseObject[key];
                      this.$set(item, key, responseObject[key]);
                    });
                  }
                });
              }
            } else {
              console.log(11);
            }
          }
        );
      } else {
        let param = {
          ...row,
          tax: row.tax
          // finalQuote:item.newFinalQuote
        };
        if (prop === "tax") {
          console.log(this.oldSeekSupplierQuoteDetails[index].tax, "old");
          console.log(row.tax, "new");
          if (this.oldSeekSupplierQuoteDetails[index].tax == row.tax) {
            this.$set(row, "taxChangeFlag", 0);
          } else {
            this.$set(row, "taxChangeFlag", 1);
          }
        }
        getShowFinalQuotePrice(param).then(res => {
          if (res.data.code === "0") {
            const responseObject = res.data.data;
            // 遍历返回对象，将值合并到 row 中
            Object.keys(responseObject).forEach(key => {
              // row[key] = responseObject[key];
              this.$set(row, key, responseObject[key]);
            });
          }
        });
      }
      // } else {
      //   // 检查输入是否为空或无效
      //   if (row[prop] === undefined || row[prop] === null || row[prop] === "") {
      //     return false;
      //   }
      //   // this.detailsLists.seekSupplierQuoteDetails.forEach(item => {
      //   //   getShowPrice({
      //   //     ...item,
      //   //     sourceSystem: this.detailsLists.sourceSystem
      //   //   }).then(res => {
      //   //     if (res.data.code === "0") {
      //   //       const responseObject = res.data.data;

      //   //       // 遍历返回对象，将值合并到 row 中
      //   //       Object.keys(responseObject).forEach(key => {
      //   //         // row[key] = responseObject[key];
      //   //         this.$set(item, key, responseObject[key]);
      //   //       });
      //   //     }
      //   //   });
      //   // });
      //   console.log(row, "row");

      //   getShowFinalQuotePrice({
      //     // ...row,
      //     // sourceSystem: this.detailsLists.sourceSystem
      //     ...row
      //   }).then(res => {
      //     if (res.data.code === "0") {
      //       const responseObject = res.data.data;

      //       // 遍历返回对象，将值合并到 row 中
      //       Object.keys(responseObject).forEach(key => {
      //         row[key] = responseObject[key];
      //       });
      //     }
      //   });
      // }
      console.log(
        this.detailsLists.seekSupplierQuoteDetails,
        "seekSupplierQuoteDetails"
      );
    },
    handleClose() {
      this.dialogVisible = false;
    },
    numberToChinese(num) {
      // 金额超出范围的处理
      if (num === 0 || !num) return "零元整";
      if (num > 9999999999999.99) return "金额超出范围";

      const cnNums = [
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖"
      ];
      const cnIntRadice = ["", "拾", "佰", "仟"];
      const cnIntUnits = ["", "万", "亿", "兆"];
      const cnDecUnits = ["角", "分"];
      const cnInteger = "整";
      const cnIntLast = "元";

      let integerNum; // 整数部分
      let decimalNum; // 小数部分
      let chineseStr = ""; // 转换后的大写中文字符串
      let parts; // 数字分段

      // 将数值保留两位小数并分割成整数和小数部分
      num = parseFloat(num).toFixed(2);
      parts = num.split(".");
      integerNum = parts[0];
      decimalNum = parts[1];

      // 转换整数部分
      if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        const intLen = integerNum.length;
        for (let i = 0; i < intLen; i++) {
          const n = integerNum.charAt(i);
          const p = intLen - i - 1;
          const q = Math.floor(p / 4);
          const m = p % 4;
          if (n === "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            zeroCount = 0; // 归零
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m === 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }

      // 转换小数部分
      if (decimalNum !== "00") {
        for (let i = 0; i < decimalNum.length; i++) {
          const n = decimalNum.charAt(i);
          if (n !== "0") {
            chineseStr += cnNums[parseInt(n)] + cnDecUnits[i];
          }
        }
      } else {
        chineseStr += cnInteger;
      }

      return chineseStr;
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-info {
  margin-top: 20px;
  width: 100%;
  background: #fff;
  padding-bottom: 150px;
}

.tab {
  height: 20px;
  color: #4a4a4a;
  background: #ebebeb;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
}

.table-top-active {
  background: #fff;
  color: #0089ef;
  font-weight: 500;
}

.bodyText {
  font-weight: 400;
  font-size: 13px;
  color: #4a4a4a;
  margin-bottom: 20px;
}

.bodyTextPadding {
  margin-right: 30px;
}

/deep/ .el-table td,
.el-table th {
  padding: 0;
}

/deep/ .el-table th,
.el-table tr:first-child {
  .cell {
    padding: 3px 5px;
  }
}

/deep/ .el-table .cell {
  //padding: 18px 5px;
}

/deep/.el-table thead {
  font-size: 13px;
}

.quotation {
  font-size: 13px;
  color: #4a4a4a;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 80px;
  top: 0;

  .time {
    > span {
      font-size: 18px;
      color: #ff142f;
      display: inline-block;
      font-weight: 500;
      margin: 10px;
      align-items: flex-end;
    }
  }
}

/deep/ .el-table__footer-wrapper tr td:nth-child(2) {
  color: #ff142f;
}

/deep/ .el-table__fixed-footer-wrapper tr td:last-child {
  color: #ff142f;
  background: #fff;
  font-weight: bold;
  font-size: 15px;
}
/deep/ .el-table__fixed-footer-wrapper tr td:first-child {
  background: #fff;
}
/deep/.el-table__fixed-footer-wrapper tbody td {
  color: #ff142f;
}
/deep/.el-table__footer-wrapper tbody td {
  background: #fff;
}

/deep/ .el-table th {
  padding: 3px 0 !important;
}
/deep/ .el-table td {
  padding: 3px 0 !important;
}
/deep/.el-table__row {
  font-size: 13px;
}

///deep/.el-table__footer-wrapper tr:last-child {
//  td{
//    border-right: none;
//
//  }
//}

.dialogBody {
  div {
    margin-bottom: 5px;
  }
}
.pitchOn {
  background: green;
  color: white;
}
.unchecked {
  background: red;
  color: white;
}

.info-item {
  display: flex;
  //align-items: center;  // 保证垂直方向上对齐
  color: #4a4a4a;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 20px;
  word-wrap: break-word; // 自动换行，防止文本内容挤压
}

.label {
  display: inline-block;
  width: 110px; // 固定宽度
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0; // 防止label被压缩
}

.info-item > span {
  white-space: normal; // 允许文本换行
  word-wrap: break-word; // 遇到长单词时进行换行
  overflow-wrap: break-word; // 同样处理单词溢出
  word-break: break-all; // 防止长单词在容器之外溢出，尽量拆分长单词
  text-overflow: ellipsis; // 当文本超出时显示省略号（可选）
  overflow: hidden; // 防止溢出
}
// /deep/.el-col-24 {
//   width: 85% !important;
// }
.header-wrap {
  position: relative;
  top: 0px;
  line-height: 36px;
  .required-red-icon {
    color: #f56c6c;
    position: absolute;
    top: 0px;
    left: 0px;
  }
}
/deep/ .curstom-input {
  .el-input__inner {
    text-align: center;
  }
  .el-input-group__append {
    padding: 0 5px;
  }
}
/deep/.el-bottom-guide .el-bottom-guide-container {
  padding: 0px 20px;
}
/deep/.el-table {
  td,
  th {
    border-right: 1px solid #edf2fc !important;
  }
  .el-table__fixed-footer-wrapper tbody td {
    background-color: #fff;
  }
}
</style>
